import(/* webpackMode: "eager" */ "/app/apps/admin/src/app/template.tsx");
